 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import HALF_TITLE from '@/components/half_title'
 import LEWIS_WALPOLE_SERIES from '@/components/lewis_walpole_series'
 import TITLE_PAGE from '@/components/title_page'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import INTRODUCTION_HOME_IMPROVEMENTS from '@/components/introduction_home_improvements'
 import A_HOW_TO_READ from '@/components/1_how_to_read'
 import A_READING_AND_SOCIABILITY from '@/components/2_reading_and_sociability'
 import A_USING_BOOKS from '@/components/3_using_books'
 import A_ACCESS_TO_READING from '@/components/4_access_to_reading'
 import A_VERSE_AT_HOME from '@/components/5_verse_at_home'
 import A_DRAMA_AND_RECITAL from '@/components/6_drama_and_recital'
 import A_FICTIONAL_WORLDS from '@/components/7_fictional_worlds'
 import A_PIETY_AND_KNOWLEDGE from '@/components/8_piety_and_knowledge'
 import AFTERWORD from '@/components/afterword'
 import NOTES from '@/components/notes'
 import INDEX from '@/components/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/half_title",
 			"name" : "half_title",
 			"component" : HALF_TITLE
 		},
 		{
 			"path" : "/lewis_walpole_series",
 			"name" : "lewis_walpole_series",
 			"component" : LEWIS_WALPOLE_SERIES
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/acknowledgments",
 			"name" : "acknowledgments",
 			"component" : ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/introduction_home_improvements",
 			"name" : "introduction_home_improvements",
 			"component" : INTRODUCTION_HOME_IMPROVEMENTS
 		},
 		{
 			"path" : "/1_how_to_read",
 			"name" : "1_how_to_read",
 			"component" : A_HOW_TO_READ
 		},
 		{
 			"path" : "/2_reading_and_sociability",
 			"name" : "2_reading_and_sociability",
 			"component" : A_READING_AND_SOCIABILITY
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js